import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";
import telematicsService from "../../../api/telematics.service";

import moment from "moment";
export default {
  name: "items-rented-report",
  components: { pageheader },
  data() {
    return {
      selectedJobiste: [],
      jobsitesList: [],
      input: {},
      reportsList: [],
      isReportLoading: false,

      exportOptions: ["Excel"],
      selectedExportOption: null,
      closeOnContentClick: false,
      isDownloading: false,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      showTable: false,

      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Department", value: "department" },
        { text: "Equipment", value: "itemName" },

        { text: "Jobsite", value: "jobsite" },

        { text: "Total Items Rented", value: "quantity" },
        { text: "Total Cost ($)", value: "cost" },
        { text: "Spend Per Equipment Unit ($)", value: "costPerEquipment" },
        { text: "Rental Contracts", value: "uniqueRentalContracts" },
        { text: "Avg Months on Rent", value: "avgMonthsOnRent" },
        { text: "Avg Days on Rent", value: "avgDaysOnRent" },
        { text: "Days On Rent", value: "daysOnRent" },
        { text: "Total Days On Rent", value: "totalRentedDays" },
      ],
      errorMSG: "Please select customer to run the report",
      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      csvName: "Rented Items.xlsx",
      isDownloadCSV: false,
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "companyNameDropdown",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
    USCurrencyFormat: function (value) {
      if (value || value == 0) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(value);
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("itemsRentedReport", this.roles);
    this.getJobsitesList();
  },
  methods: {
    async getJobsitesList() {
      try {
        this.isJobsitesLoading = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobsitesList = response.data.filter(
            (e) => e.locationName != null
          );
          this.isJobsitesLoading = false;
        }
      } catch (err) {
        this.isJobsitesLoading = false;
        console.log(err);
      }
    },
    async getReportList() {
      this.isReportLoading = true;
      try {
        let response = await smsService.getItemsRentedReport(
          this.fromDate,
          this.toDate,
          this.selectedJobiste.join(",")
        );
        if (response) {
          this.showTable = true;
          this.reportsList = response.data;
          this.isReportLoading = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportGetItemsRentedReport(
          exportOption,
          this.fromDate,
          this.toDate,
          this.selectedJobiste.join(",")
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.selectedJobiste = [];
      this.reportsList = [];
      this.getReportList();
    },
  },
};
